import React, { useEffect } from "react";
import styles from "./SubmitPage.module.css";
import { useDispatch, useSelector } from "react-redux";
import { Grid, Typography } from "@mui/material";
import { Box } from "@mui/system";
import { customTextColor, splitIntoColumns } from "../../../utils/const";
import { allSkill } from "../../../redux/common/skillSlice";
import { allLocation } from "../../../redux/common/locationSlice";
import { allWorkAuthorization } from "../../../redux/common/workAuthorizationSlice";
import { getProfile } from "../../../redux/profile/profileSlice";
import {
  checkCandidateExist,
  createCandidateProfile,
  createExistCandidateProfile,
  getAllCandidate,
} from "../../../redux/candidate/candidateSlice";
import { useNavigate } from "react-router-dom";

const SubmitPage = ({ setMenuName, setMenuId }) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const personalDetails = useSelector(
    (state) => state.internalCandidateStatic.data
  );
  const skillsExperience = useSelector(
    (state) => state.internalCandidateStatic.peviousExperienceData
  );
  const officialReference = useSelector(
    (state) => state.internalCandidateStatic.officialReferenceData
  );
  const workautho = useSelector((state) => state.workautho);
  const locations = useSelector((state) => state.location) || [];
  const skillData = useSelector((state) => state.skill.data);
  const profile = useSelector((state) => state.profile.data);

  const searchData = useSelector((state) => state.candidate.searchData);
  const candidateStatus = useSelector((state) => state.candidate.status);

  useEffect(() => {
    dispatch(allSkill());
    dispatch(allLocation());
    dispatch(allWorkAuthorization());
  }, []);

  const matchingSkills = skillData?.locations?.filter((skill) =>
    skillsExperience?.skills?.includes(skill.id)
  );
  const columns = splitIntoColumns(matchingSkills, 4);

  const matchingSkills2 = skillData?.locations?.filter((skill) =>
    skillsExperience?.secondary_skills?.includes(skill.id)
  );
  const columns2 = splitIntoColumns(matchingSkills2, 4);

  const handleOnClickEdit = () => {
    setMenuName("Persional Details");
    setMenuId(0);
  };

  useEffect(() => {
    dispatch(getProfile());
  }, [dispatch]);

  useEffect(() => {
    let mobile_no = personalDetails?.mobile_no?.replace(/[^0-9]/g, "");
    let email = personalDetails?.email;

    dispatch(checkCandidateExist({ email, mobile_no }));
  }, [personalDetails]);

  let userData = {
    email: personalDetails?.email,
    mobile_no: parseInt(personalDetails?.mobile_no?.replace(/[^0-9]/g, ""), 10),
    alternative_mobile_no: personalDetails?.alternative_mobile_no?.replace(
      /[^0-9]/g,
      ""
    ),
    full_name: personalDetails?.full_name,
    gender: "Male",
    current_job_title: personalDetails?.current_job_title,
    total_experience: Number(personalDetails?.total_experience),
    current_location: personalDetails?.current_location,
    prefer_location: personalDetails?.prefer_location,
    work_authorization: `${personalDetails?.work_authorization}`,
    prefer_tax_team: personalDetails?.prefer_tax_team,
    prefer_tax_team: "working_in_all",
    p_tax_team: personalDetails?.prefer_tax_team,
    work_preference: personalDetails?.work_preference,
    previous_experience: JSON.stringify(skillsExperience?.previous_experience),
    //   rate: personalDetails?.rate,
    rate: Number(personalDetails?.rate),
    linkedin_profile_url: personalDetails?.linkedin_profile_url,
    resume: personalDetails?.resume,
    current_company:
      skillsExperience?.previous_experience?.length > 0
        ? skillsExperience?.previous_experience[0]?.duration_to === null
          ? skillsExperience?.previous_experience[0]?.industry_of_the_company
          : null
        : null,
    passing_year: personalDetails?.passing_year,
    passing_year: `${personalDetails?.passing_year}`,
    highest_qualification: personalDetails?.highest_qualification,
    university: personalDetails?.university,
    skills: skillsExperience?.skills,
    secondary_skills: JSON.stringify(skillsExperience?.secondary_skills),
    referrer_company_name: officialReference?.referrer_company_name,
    referrer_mobile_no: officialReference?.referrer_mobile_no,
    referrer_email: officialReference?.referrer_email,
    referrer_company_name2: officialReference?.referrer_company_name2,
    referrer_mobile_no2: officialReference?.referrer_mobile_no2,
    referrer_email2: officialReference?.referrer_email2,
    referrer_manager_name: officialReference?.referrer_manager_name,
    referrer_manager_name2: officialReference?.referrer_manager_name2,
    role: "CANDIDATE",
    recruiter_user_id: profile?.profile?.user_id,
    candidate: searchData?.candidate_id,
  };

  const handleOnSubmitTracker = () => {
    if (searchData?.exist) {
      dispatch(createExistCandidateProfile(userData));
    } else {
      dispatch(createCandidateProfile(userData));
    }
    // }
  };

  useEffect(() => {
    if (
      candidateStatus === "create_candidate_profile" ||
      candidateStatus === "create_candidate_exist_profile"
    ) {
      dispatch(getAllCandidate());
      navigate("/candidate-listing");
    }
  }, [candidateStatus]);

  const getLocationById = (id) => {
    let locationResult = locations?.data?.locations?.find(
      (res) => res.id === id
    );
    return locationResult?.name;
  };

  const getWorkAuthorization = (id) => {
    let authorizationResult = workautho?.data?.work_authorization_data?.find(
      (res) => res.id === id
    );
    return authorizationResult?.name;
  };
  const getPreferLocationNames = (preferLocation) => {
    return preferLocation
      ?.map(
        (id) =>
          locations?.data?.locations?.find((location) => location.id === id)
            ?.name
      ) // Map IDs to names
      ?.filter(Boolean) // Remove any undefined values if IDs don't match
      ?.join(", "); // Join names with a comma and space
  };

  return (
    <div className={styles.container}>
      {/* Personal Details Section */}
      <section className={styles.section}>
        <h2 className={styles.sectionTitle} style={{ marginBottom: "20px" }}>
          Candidate Details
        </h2>
        <Grid container>
          <Grid item xs={12} sm={6} md={6} lg={6}>
            <ul
              style={{
                listStyleType: "square",
                padding: "5px 20px",
                marginBottom: "10px",
              }}
            >
              <li>
                <p>
                  <strong>Name:</strong> {personalDetails.full_name}
                </p>
              </li>

              <li>
                <p>
                  <strong>Experience:</strong>{" "}
                  {personalDetails.total_experience} years
                </p>
              </li>

              <li>
                <p>
                  <strong>E-Mail ID:</strong> {personalDetails.email}
                </p>
              </li>

              <li>
                <p>
                  <strong>Alternative Mobile:</strong>{" "}
                  {personalDetails.alternative_mobile_no}
                </p>
              </li>

              <li>
                <p>
                  <strong>Curent Location:</strong>{" "}
                  {getLocationById(personalDetails.current_location)}
                </p>
              </li>

              <li>
                <p>
                  <strong>Mode of Hiring::</strong>{" "}
                  {personalDetails.prefer_tax_team}
                </p>
              </li>

              <li>
                <p>
                  <strong>Work Preference:</strong>{" "}
                  {personalDetails.work_preference}
                </p>
              </li>

              <li>
                <p>
                  <strong>University:</strong> {personalDetails.university}
                </p>
              </li>
            </ul>
          </Grid>
          <Grid item xs={12} sm={6} md={6} lg={6}>
            <ul
              style={{
                listStyleType: "square",
                padding: "5px 20px",
                marginBottom: "10px",
              }}
            >
              <li>
                <p>
                  <strong>Job Profile:</strong>{" "}
                  {personalDetails.current_job_title}
                </p>
              </li>

              <li>
                <p>
                  <strong>Phone No:</strong> {personalDetails.mobile_no}
                </p>
              </li>

              <li>
                <p>
                  <strong>Preferred Location:</strong>{" "}
                  {getPreferLocationNames(personalDetails.prefer_location)}
                </p>
              </li>

              <li>
                <p>
                  <strong>Passing Year:</strong> {personalDetails.passing_year}
                </p>
              </li>

              <li>
                <p>
                  <strong>Rate:</strong> {personalDetails.rate}
                </p>
              </li>

              <li>
                <p>
                  <strong>Highest Qualification:</strong>{" "}
                  {personalDetails.highest_qualification}
                </p>
              </li>

              <li>
                <p>
                  <strong>Linkedin ID:</strong>{" "}
                  {personalDetails.linkedin_profile_url}
                </p>
              </li>

              <li>
                <p>
                  <strong>Work Authorization:</strong>{" "}
                  {getWorkAuthorization(personalDetails.work_authorization)}
                </p>
              </li>
            </ul>
          </Grid>
        </Grid>
      </section>

      {/* Skills and Experience Section */}
      <section className={styles.section}>
        {/* <h2 className={styles.sectionTitle}>Skills and Experience</h2> */}

        <Grid container sx={{ backgroundColor: "#fff" }}>
          <Grid item xs={12}>
            <Box className={styles.list_details}>
              <Typography sx={{ marginBottom: "20px !important" }}>
                <b>Primary skills</b>
              </Typography>
              <Grid container sx={{ fontWeight: "600" }}>
                {columns.map((column, colIndex) => (
                  <Grid
                    item
                    xs={6}
                    sm={6}
                    md={3}
                    lg={3}
                    key={colIndex}
                    sx={{
                      borderLeft: colIndex !== 0 ? "2px solid white" : "none",
                      paddingLeft: colIndex !== 0 ? "20px" : "0",
                    }}
                  >
                    <Box sx={{ color: customTextColor }}>
                      {column.map((skill) => (
                        <Typography
                          key={skill.id}
                          sx={{ marginBottom: "0 !important" }}
                        >
                          {skill.name}
                        </Typography>
                      ))}
                    </Box>
                  </Grid>
                ))}
              </Grid>
            </Box>
          </Grid>
        </Grid>
      </section>
      <section className={styles.section}>
        <Grid container sx={{ backgroundColor: "#fff", margin: "14px 0" }}>
          <Grid item xs={12}>
            <Box className={styles.list_details}>
              <Typography sx={{ marginBottom: "20px !important" }}>
                <b>Secondary skills</b>
              </Typography>
              <Grid container sx={{ fontWeight: "600" }}>
                {columns2.map((column, colIndex) => (
                  <Grid
                    item
                    xs={6}
                    sm={6}
                    md={3}
                    lg={3}
                    key={colIndex}
                    sx={{
                      borderLeft: colIndex !== 0 ? "2px solid white" : "none",
                      paddingLeft: colIndex !== 0 ? "20px" : "0",
                    }}
                  >
                    <Box sx={{ color: customTextColor }}>
                      {column.map((skill) => (
                        <Typography
                          key={skill.id}
                          sx={{ marginBottom: "0 !important" }}
                        >
                          {skill.name}
                        </Typography>
                      ))}
                    </Box>
                  </Grid>
                ))}
              </Grid>
            </Box>
          </Grid>
        </Grid>
      </section>
      <section className={styles.section}>
        {skillsExperience?.previous_experience ? (
          skillsExperience?.previous_experience?.map((prevData, index) => {
            return (
              <Box className={styles.full_details} key={index}>
                <Box sx={{ marginLeft: "20px" }}>
                  <Typography>
                    <b>{prevData?.role}</b>
                  </Typography>
                  <Typography>{prevData?.company}</Typography>
                  <Typography>{prevData?.industry_of_the_company}</Typography>
                  <Typography
                    sx={{
                      display: "flex",
                      justifyContent: "end",
                      position: "relative",
                      bottom: "60px",
                      marginTop: "10px",
                    }}
                  >
                    {prevData?.duration_from} to {prevData?.duration_to}
                  </Typography>
                </Box>
                <ul>
                  {prevData?.summary_of_work.map((text, index) => (
                    <li key={index}>{text}</li>
                  ))}
                </ul>
              </Box>
            );
          })
        ) : (
          <p>No Experience Found</p>
        )}

        {/* {skillsExperience.previous_experience.map((job, index) => (
          <div key={index} className={styles.jobSection}>
            <h3>
              {job.role} at {job.company}
            </h3>
            <p>
              <strong>Industry:</strong> {job.industry_of_the_company}
            </p>
            <p>
              <strong>Duration:</strong> {job.duration_from} -{" "}
              {job.duration_to || "Present"}
            </p>
            <ul>
              {job.summary_of_work.map((task, idx) => (
                <li key={idx}>{task}</li>
              ))}
            </ul>
          </div>
        ))} */}
      </section>

      {/* Official Reference Section */}
      <section className={styles.section}>
        <h2 className={styles.sectionTitle}>Official Reference</h2>
        <div className={styles.detailsGrid}>
          <p>
            <strong>Referrer Company:</strong>{" "}
            {officialReference.referrer_company_name}
          </p>
          <p>
            <strong>Referrer Manager:</strong>{" "}
            {officialReference.referrer_manager_name}
          </p>
          <p>
            <strong>Referrer Email:</strong> {officialReference.referrer_email}
          </p>
          <p>
            <strong>Referrer Mobile:</strong>{" "}
            {officialReference.referrer_mobile_no}
          </p>
        </div>
      </section>
      <div className={styles.submitButton}>
        <button
          style={{ backgroundColor: "#3e83eb", padding: "10px 28px" }}
          onClick={handleOnClickEdit}
          disabled={candidateStatus === "loading"}
        >
          Edit
        </button>
        <button
          disabled={candidateStatus === "loading"}
          onClick={handleOnSubmitTracker}
        >
          {candidateStatus === "loading" ? "Loading" : "Submit"}
        </button>
      </div>
    </div>
  );
};

export default SubmitPage;
